var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.2 423.7H8.8c-4.9 0-8.8-4-8.8-8.8V97.1c0-4.9 4-8.8 8.8-8.8h494.3c4.9 0 8.8 4 8.8 8.8v317.8c.1 4.9-3.9 8.8-8.7 8.8z",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.2 423.7H8.8c-4.9 0-8.8-4-8.8-8.8v-44.1h512v44.1c0 4.9-4 8.8-8.8 8.8zM8.8 88.3h494.3c4.9 0 8.8 4 8.8 8.8v44.1H0V97.1c0-4.9 4-8.8 8.8-8.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M0 194.2h512v123.6H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/th.1a0275002667890bbe62c59373e6e3fa.svg";
export { ForwardRef as ReactComponent };